import { render, staticRenderFns } from "./FAQItem.vue?vue&type=template&id=eb97e2da&scoped=true"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"
import style0 from "./FAQItem.vue?vue&type=style&index=0&id=eb97e2da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb97e2da",
  null
  
)

export default component.exports